import axios from "axios";
import {
  onRequest,
  onRequestError,
  onResponse,
  onResponseError,
} from "./api-interceptors";
import { selectAuthToken } from "../redux/reducers/authReducers";
import { store } from "../redux/store";

// export const BASE_URL = "http://localhost:5001"
export const BASE_URL = "https://api-sire.solminds.com"

const defaultOptions = {
  baseURL: `${BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
};
const instance = axios.create(defaultOptions);

instance.interceptors.request.use(
  (config) => {
    const token = selectAuthToken(store.getState());
    if(token){
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => onResponse(response),
  (error) => onResponseError(error)
);
export default instance;
